<template>
    <div class="modal fade" :id="`modal-dosage-${order_id}`" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">วิธีรับประทาน</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        v-on:click="close"></button>
                </div>
                <div class="modal-body">
                    <div v-if="!isLoading" class="row" style="max-height: 500px; overflow-y: auto;">
                        <template v-for="item in dosages">
                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <div class="d-flex">
                                        <span v-if="item.display_product_name" class="fw-bold" style="font-size: 18px;">{{ item.display_product_name }}</span>
                                        <span v-else class="fw-bold" style="font-size: 18px;">{{ item.product_name }}</span>
                                    </div>
                                    <div class="d-flex flex-column">
                                        <span class="text-start fw-bold">วิธีการใช้ยา</span>
                                        <div class="d-flex">
                                            <span v-if="item.dosage > 0">
                                                ครั้งละ {{ item.dosage }} {{ item.dosage_unit }}&nbsp;
                                            </span>
                                            <span v-if="item.take_before_meal">หลังอาหาร
                                            </span>
                                            <span v-if="item.take_before_meal == 0">ก่อนอาหาร
                                            </span>
                                            <span v-if="item.daily > 0">
                                                &nbsp;{{ item.daily }} ครั้ง
                                            </span>
                                        </div>
                                        <div class="d-flex flex-wrap text-start">
                                            <span v-if="!item.is_same_qty">
                                                <span>
                                                    <span v-if="item.morning">เช้า
                                                        {{ item.morning_amount }}
                                                        {{ item.dosage_unit }}
                                                    </span>
                                                    <span v-if="item.noon">กลางวัน
                                                        {{ item.noon_amount }}
                                                        {{ item.dosage_unit }}
                                                    </span>
                                                    <span v-if="item.evening">เย็น
                                                        {{ item.evening_amount }}
                                                        {{ item.dosage_unit }}
                                                    </span>
                                                    <span v-if="item.before_bedtime">ก่อนนอน
                                                        {{ item.before_bedtime_amount }}
                                                        {{ item.dosage_unit }}
                                                    </span>
                                                    <span v-if="item.have_symptom">เวลามีอาการ
                                                        {{ item.have_symptom_amount }}
                                                        {{ item.dosage_unit }}
                                                    </span>
                                                    <span v-if="item.every_hour">
                                                        ทุก
                                                        {{ item.every_hour_amount }}
                                                        {{ item.interval_unit }}
                                                    </span>
                                                </span>
                                            </span>
                                            <span v-else>
                                                <span v-if="item.morning">เช้า
                                                </span>
                                                <span v-if="item.noon">กลางวัน
                                                </span>
                                                <span v-if="item.evening">เย็น
                                                </span>

                                                <span v-if="item.before_bedtime">ก่อนนอน
                                                </span>
                                                <span v-if="item.every_hour">
                                                    ทุก
                                                    {{ item.every_hour_amount }}
                                                    {{ item.interval_unit }}
                                                </span>
                                                <span v-if="item.have_symptom">
                                                    , เมื่อมีอาการ
                                                </span>
                                            </span>
                                        </div>
                                        <div class="d-flex">
                                            <p v-if="item.remark" class="mb-0 mt-1 fs-xs">
                                                <span>หมายเหตุ</span> : {{ item.remark }}
                                            </p>
                                        </div>
                                    </div>
                                    <hr>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-else>
                        <line-loading />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
export default {
    props: ['order_id'],
    data() {
        return {
            modal: null,
            dosages: [],
            isLoading: true,
            accessToken: null,
            line_user_id: null
        }
    },
    mounted() {
        this.accessToken = localStorage.getItem('access_token')
        this.line_user_id = localStorage.getItem('line_user_id')
    },
    methods: {
        async getDosages() {
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + this.accessToken,
                    'Content-Type': 'application/json'
                }
            }
            let res = await axios.post("/liff/get-dosages", {
                order_id: this.order_id,
                line_user_id: this.line_user_id
            }, config)

            if (res.data.success) {
                this.dosages = res.data.dosages
                this.isLoading = false;
            }

        },
        open() {
            this.getDosages();
            this.modal = new Modal(document.getElementById('modal-dosage-' + this.order_id), {})
            this.modal.show()
        },
        close() {
            this.modal.hide()
        }
    }
}
</script>
